import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CreateProjectMilestone } from '../../../../domain/projectMilestones/createProjectMilestone';
import { ProjectMilestoneModel } from '../../../../domain/projectMilestones/projectMilestoneModel';
import { UpdatedProjectMilestone } from '../../../../domain/projectMilestones/updateProjectMilestone';
import { ProjectMilestoneRepository } from '../../../../infrastructure/repositories/projectMilestones/projectMilestoneRepository';
import { Private_Routes } from '../../../../main/constants';
import FormErrorMessage from '../../../shared/components/forms/FormErrorMessage';
import MilestoneDetailSection from './MilestoneDetailSection';

interface Props {
    isNewProjectMilestone: boolean;
    projectMilestone?: ProjectMilestoneModel | null;
}

export const ProjectMilestoneForm = ({
    isNewProjectMilestone,
    projectMilestone: selectedMilestone,
}: Props) => {
    const initialState = selectedMilestone ?? {
        id: 0,
        name: '',
        typeProject: '',
        ordinality: 0,
    };

    const [milestone, setMilestone] = useState<ProjectMilestoneModel>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isIncomplete, setIsIncomplete] = useState(true);

    const navigate = useNavigate();

    const handleInputChange = (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => {
        setMilestone({ ...milestone, [name]: value });
    };

    const handleError = (error: any) => {
        setErrorMessage(error.response.data);
        setIsSubmitting(false);
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage('');

        if (isNewProjectMilestone) {
            let body: CreateProjectMilestone = {
                name: milestone.name,
                typeProject: milestone.typeProject,
                ordinality: milestone.ordinality,
            };

            ProjectMilestoneRepository.CreateProjectMilestone(body)
                .then((response) => {
                    navigate(Private_Routes.PROJECT_MILESTONE_PAGE);
                    setIsSubmitting(false);
                })
                .catch(handleError);
        } else {
            let body: UpdatedProjectMilestone = {
                name: milestone.name,
                ordinality: milestone.ordinality,
                typeProject: milestone.typeProject,
            };

            ProjectMilestoneRepository.UpdateProjectMilestone(milestone.id, body)
                .then((response) => {
                    navigate(Private_Routes.PROJECT_MILESTONE_PAGE);
                    setIsSubmitting(false);
                })
                .catch(handleError);
        }
    };

    useEffect(() => {
        if (
            milestone.ordinality > 0 &&
            milestone.name !== '' &&
            milestone.typeProject !== ''
        ) {
            setIsIncomplete(false);
        } else {
            setIsIncomplete(true);
        }
    }, [milestone]);

    return (
        <div>
            <FormErrorMessage errorMessage={errorMessage} />
            <div className='row'>
                <div className='col-xxl-12'>
                    <div className='card '>
                        <div className='card-body p-4'>
                            <div className='row'>
                                <MilestoneDetailSection
                                    projectMilestone={milestone}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <Link
                        to={Private_Routes.PROJECT_MILESTONE_PAGE}
                        className='btn btn-withe'
                    >
                        <i className='mdi mdi-arrow-left'></i> Atrás
                    </Link>

                    {isNewProjectMilestone ? (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? 'Creando...' : 'Crear'}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            <i className='ri-arrow-up-circle-line'></i>
                            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
